import { render } from "./ClientesDropdown.vue?vue&type=template&id=bb459e92"
import script from "./ClientesDropdown.vue?vue&type=script&lang=js"
export * from "./ClientesDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__